import React from "react";
import { answers } from "../../data/site";
import { AnswerSection } from "../answers/AnswerSection";
export function CommonAnswers() {
  return <section id="answers" aria-labelledby="answers-title" className="bg-white" data-id="element-178" data-mp="1gv5ieayd269x">
      <div className="page-container py-12 md:py-16" data-id="element-179" data-mp="1c22p83xhwyu9">
        <h2 id="answers-title" className="text-h2-m font-extrabold text-ink md:text-h2" data-id="element-180" data-mp="174u2rr5be8n7">
          Questions after a motorcycle crash
        </h2>
        <div className="mt-7 divide-y divide-line border-y border-line md:mt-8" data-id="element-181" data-mp="1270yx4rhhqq3">
          {answers.map(item => <AnswerSection key={item.id} {...item} data-id="element-182" data-mp="y5z0gq5e5ip6" />)}
        </div>
      </div>
    </section>;
}